import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { SnapshotFormat } from 'webapp/enums/enums';
import { TrackingEvent } from 'webapp/enums/tracking';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type InfolayerItem from 'webapp/models-custom/infolayer-item/loop-pdf';

interface Args {
	model: InfolayerItem;
	onClose: () => void;
}

export default class InfolayerTypeLoopPdfComponent extends Component<Args> {
	@service('analytics') declare analyticsService: Service.Analytics;

	get title() {
		return this.args.model.loop.title;
	}

	@action
	download(): void {
		const url = this.args.model.snapshotData?.[0]?.url;
		if (url) {
			this.analyticsService.event(TrackingEvent.DATABOARD_DOWNLOADED, {
				name: this.title,
				datasources: this.args.model.loop.specificSourceTypesKeys,
				origin: 'databoard_preview',
				format: SnapshotFormat.PDF,
				type: 'loop',
			});
			window.open(url);
			this.args.onClose();
		}
	}

	<template>
		<div role="button" class="infolayer infolayer--type-loop-pdf {{@model.classes}}">
			<div>
				<CommonUiIconComponent @name="Loop" @size="lg" @class="infolayer-icon" />
				{{#if @model.isLoading}}
					<p>
						Your looped dashboard
						<strong>"{{this.title}}"</strong>
						(PDF) is being prepared.
					</p>
				{{else if @model.isError}}
					<p>
						We've encountered the following error while generating your PDF
						<strong>"{{this.title}}"</strong>
						:{{@model.errorText}}
					</p>
				{{else}}
					<p>
						<strong>{{this.title}}</strong>
					</p>
					<div class="controls2">
						<div class="controls2__right">
							<a class="close" {{on "click" @onClose}}>Dismiss</a>
							<a class="button" {{on "click" this.download}}>
								<CommonUiIconComponent @name="Download" @size="sm" />Download
							</a>
						</div>
					</div>
				{{/if}}
			</div>
		</div>
	</template>
}
